import React, { Component } from 'react';

class Ring extends Component {
  render() {
    return (
      <div className='center'>
        <img src={`./overline.png`}  style={{height:'100px',marginTop:'5px',paddingRight:0}} />
        <h4 style={{color:'white',marginTop:'10px'}}>OVERLINE</h4>
      </div>
    )
  }
}

export default Ring;
